/**
 * Sub-group participants are identified by a key: "user:<id>" for trip
 * members and "invite:<id>" for invitees who have not joined yet. Plain
 * numeric ids are treated as user ids for older data.
 */

export const PARTICIPANT_STATUS_LABEL_KEYS = {
  pending: 'activityModal.participantInvited',
  declined: 'activityModal.participantDeclined',
};

export const normalizeParticipantKey = (value) => {
  const text = String(value ?? '').trim();
  return /^\d+$/.test(text) ? `user:${text}` : text;
};

export const getParticipantKey = (person) => {
  if (!person) return '';
  if (person.participant_key) return person.participant_key;
  if (person.invitation_id) return `invite:${person.invitation_id}`;
  return normalizeParticipantKey(person.user_id ?? person.id);
};

export const toParticipantKeySet = (participants = []) =>
  new Set(participants.map(normalizeParticipantKey).filter(Boolean));
